import { render, staticRenderFns } from "./ChoferExport.vue?vue&type=template&id=2b8ad558"
import script from "./ChoferExport.vue?vue&type=script&lang=js"
export * from "./ChoferExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports